import 'angular:locale/data:de';
import 'angular:locale/data:en';
import 'zone.js';
import 'zone.js/testing';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
